import * as _4 from 'lodash4';
import { StringUtility } from 'utility-ts-type';
import { MajorDataToggleService } from '../../data/services/major_data_toggle_service';
import { ICareerEducation, ICareerExperience, IMajorCareer, IMajorGeneralFlag } from '../../major_explorer_interface';

export class MajorTileCareerController {
  private career: IMajorCareer;
  private flags: IMajorGeneralFlag;

  constructor(private majorDataToggleService: MajorDataToggleService) {}

  $onInit(): void {
    this.flags = {
      showSalary: this.majorDataToggleService.toggles.salary,
      showJobDemand: this.majorDataToggleService.toggles.hiringDemand,
      showTuition: this.majorDataToggleService.toggles.tution,
      showDevCourses: this.majorDataToggleService.toggles.devCourses,
      showCourseMaps: this.majorDataToggleService.toggles.courseMaps,
      showCredits: false
    };
    this.career.shortDesc = StringUtility.truncateString(100, this.career.desc);
  }

  getNumberInThousands(number: number): string {
    return '$' + Math.round(number / 1000) + 'K';
  }

  showAverageSalary(): boolean {
    return this.career && this.career.salaryMax !== '$0k';
  }

  hasChildren(list: ICareerEducation[] | ICareerExperience[]): boolean {
    return !_4.isEmpty(list);
  }

  isNotLargest(compareItem: ICareerEducation, list: ICareerEducation[]): boolean {
    let isLargest = true;

    list.forEach((item: any) => {
      if (compareItem.value < item.value) {
        isLargest = false;
      }
    });

    return !isLargest;
  }

  showEmployerInfo(): boolean {
    return this.hasChildren(this.career.education) && this.hasChildren(this.career.experience);
  }
}

export class MajorTileCareerComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-major-explorer/src/components/major_tile_career/major_tile_career.html';
  public controller: any = MajorTileCareerController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    career: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_tile_career/major_tile_career_controller.ts